import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class SuporteWhatsappService extends ServerService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  obtenhaContexto(chatId: string, nomeGrupo: string): Promise<any> {
    return this.facaPost('/suporte/whatsapp/contexto', { chatId, nomeGrupo });
  }

  vinculeGrupo(chatId: string, nomeGrupo: string, empresaSuporteId: number): Promise<any> {
    return this.facaPost('/suporte/whatsapp/grupos/vincular', {
      chatId,
      nomeGrupo,
      empresaSuporteId
    });
  }

  desvinculeGrupo(chatId: string, nomeGrupo: string, justificativa: string): Promise<any> {
    return this.facaPost('/suporte/whatsapp/grupos/desvincular', {
      chatId,
      nomeGrupo,
      justificativa
    });
  }

  listeEmpresas(termo: string): Promise<any[]> {
    return this.obtenha('/suporte/empresas', { termo: termo || '' });
  }
}
